






import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "./components/main-header/main-header.vue";
@Component({
  data: () => {
    return {};
  },
  methods: {},
  components: {
    Header
  }
})
export default class MainView extends Vue {
  private msg!: string;
}
